/* @flow */

import * as React from 'react';
import useMounted from './useMounted';
import { isClient } from 'src/shared/core/util/ssrUtil';
import useResizeObserver from '@react-hook/resize-observer';

export default function useFixed() {
  const ref = React.useRef<?HTMLElement>();

  const isMounted = useMounted();
  const [innerStyles, setInnerStyles] = React.useState({
    left: 'auto',
    width: 'auto',
  });

  const evaluateLayout = () => {
    if (ref.current && isClient) {
      const parent = ref.current.parentElement;

      if (parent instanceof HTMLElement) {
        // $FlowIssue
        const posTop =
          parent.getBoundingClientRect().top +
            document.documentElement?.scrollTop || 0;
        const width = parent.offsetWidth;

        setInnerStyles({
          width,
          top: posTop,
          position: 'fixed',
        });
      }
    }
  };
  useResizeObserver(ref.current?.parentElement, () => evaluateLayout());

  React.useEffect(() => {
    evaluateLayout();
  }, [isMounted]);

  return {
    innerProps: { ref, style: innerStyles },
  };
}
